import { PineappleIcon } from "@/components/PineappleIcon";
import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div className="overflow-hidden border-y border-gold/25 bg-cream py-5" data-testid="editorial-marquee">
      <div className="flex w-max animate-marquee items-center whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center font-serif text-lg italic text-charcoal/75 sm:text-xl">
            <span className="px-8">{item}</span>
            <PineappleIcon className="h-5 w-4 text-gold/70" />
          </span>
        ))}
      </div>
    </div>
  );
};
